import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Grid, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { useSelector } from '../../../redux/store';
import { COMPLETED_TICKETS } from '../../../reusable-components/datagrid/ticketColumns';
import CustomToolbar from './CustomToolbar';
import CustomDataGrid from '../../../reusable-components/datagrid/CustomDataGrid';
import ManagerChipsWrapper from '../../../reusable-components/datagrid/ManagerChipsWrapper';
import { getCompletedTickets } from '../../../redux/slices/tickets';
import { useGridScrollRestore } from '../../../hooks/useGridScrollRestore';

export default function CompletedTickets() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const start = searchParams.get('start');
  const end = searchParams.get('end');
  const apiRef = useGridApiRef();
  const gridId = 'completed-tickets';

  const [showSelection, setShowSelection] = useState('');
  const [selected, setSelected] = useState([]);
  const [isTicketsLoaded, setIsTicketsLoaded] = useState(false);
  const { data: { completedTickets, isLoading } } = useSelector((state) => state.tickets);

  const { saveScrollAnchor } = useGridScrollRestore({ gridId, apiRef, ready: isTicketsLoaded });

  const customToolbar = () => (
    <CustomToolbar setShowSelection={setShowSelection} showSelection={showSelection} selected={selected} />
  );

  const rowClick = (id) => {
    saveScrollAnchor();
    navigate(`/dashboard/tickets/${id}?start=${start}&end=${end}`);
  };

  useEffect(() => {
    if(start && end) {
      setIsTicketsLoaded(false);
      dispatch(getCompletedTickets({ startDate: start, endDate: end })).then(() => setIsTicketsLoaded(true));
    }
  }, [start, end]);

  return (
    <>
      <Grid item xs={12}>
        <Box id="completed-tickets-grid">
          <CustomDataGrid
            gridId={gridId}
            apiRef={apiRef}
            boxSX={{ height: 'calc(100vh - 225px)' }}
            getRowHeight={() => 'auto'}
            data={completedTickets}
            gridColumns={[
              ...COMPLETED_TICKETS,
              ManagerChipsWrapper(null, 'Tickets', null, {
                flex: 3,
                minWidth: 180,
              }),
            ]}
            checkboxSelection={!!showSelection}
            onRowSelectionModelChange={(newSelection) => {
              setSelected(newSelection);
            }}
            forceReRender={selected}
            onRowClick={(params, e) => {
              const selection = window.getSelection().toString();
              if (selection.length > 0) return;
              rowClick(params.row.id);
            }}
            loading={isLoading}
            CustomLeftToolbar={customToolbar}
            applyQuickFilter
            advancedFilter
            advancedSearchBase="tickets"
            quickfilterHiddenSearchCol={{ field: "lastMessage" }}
          />
        </Box>
      </Grid>
    </>
  );
}
